module.exports = __webpack_public_path__ + "static/video-pack-e3442b52e5651def7e578055b3cd8857.png";